import init from './init';

export default new Proxy({}, {
    get(target, property) {
        return init.params.config[property];
    }
});